import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { UserApiV2 } from './types/User';
import { APIV2_URL } from './constants';

export interface Payload {
  email: string;
  password: string;
}

const login = (makeCall: MakeCall) => (data: Payload) =>
  makeCall<UserApiV2>('POST', `${APIV2_URL}/action/login`, { data });

export default login;
